export default __webpack_public_path__ + "static/socsite-fdf63064945eeb153844864a4be81100.jpg";